var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 972.869 743.32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Subtract",
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.414 299.285H490.455L659.3 0H972.869L667.34 514.209L840.99 742.218L523.412 742.229L490.455 723.105H482.414L470.836 743.32H165.138L307.539 514.209L0 0H311.56L482.414 299.285Z",
    fill: "var(--fill-0, #EB0028)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroX);
export default __webpack_public_path__ + "static/media/hero-x.9c3a9cc8859d68d67169d4a811077034.svg";
export { ForwardRef as ReactComponent };